import { Box, LoadingOverlay } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { accountApi } from '@/api/accountApi'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { RouterPath } from '@/router/paths'
import { showToast } from '@/theme/notifications'
import { AuthLayout } from '../layout/AuthLayout/AuthLayout'
import { PasswordResetConfirmation } from './PasswordResetConfirmation/PasswordResetConfirmation'
import {
  FormValues,
  PasswordResetForm
} from './PasswordResetForm/PasswordResetForm'

export const ForgotPasswordPage = () => {
  const intl = useIntl()
  const [showConfirmation, setShowConfirmation] = useState(false)

  const { mutate, isPending } = useMutation({
    mutationFn: accountApi.sendPasswordResetEmail,
    onSuccess: () => {
      setShowConfirmation(true)
    },
    onError: (err) => {
      showToast(
        extractErrorMessage(
          err,
          intl.formatMessage({ id: 'passwordReset.sendEmailError' })
        ),
        'error'
      )
    }
  })

  const onTryAgainClick = () => {
    setShowConfirmation(false)
  }

  const onSubmit = (formValues: FormValues) => {
    if (!isPending) {
      mutate({ email: formValues.email })
    }
  }

  return showConfirmation ? (
    <AuthLayout>
      <PasswordResetConfirmation onTryAgainClick={onTryAgainClick} />
    </AuthLayout>
  ) : (
    <AuthLayout>
      <Box pos="relative">
        <LoadingOverlay visible={isPending} />

        <PasswordResetForm loginLink={RouterPath.login} onSubmit={onSubmit} />
      </Box>
    </AuthLayout>
  )
}
